import React from "react";
import classes from "./ColorMode.module.scss";

const ColorMode = ({ theme, setTheme }) => {
  const colorModeHandler = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <div className={classes.colorMode}>
      <svg
        onClick={colorModeHandler}
        fill="#000000"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="48px"
        height="48px"
      >
        <path d="M41.826,40.005c-0.187-0.581-0.724-0.974-1.335-0.979c-5.647-0.032-12.645-5.157-14.634-8.141l1.712-1.141 c0.429-0.287,0.667-0.787,0.62-1.305c-0.046-0.515-0.371-0.963-0.848-1.17c-0.041-0.018-0.435-0.196-0.96-0.598 c1.185-0.891,1.976-2.434,2.086-4.254C29.065,22.221,29.5,21.664,29.5,21c0-0.828-0.671-1.5-1.5-1.5h-4.339 c0.315-7.229,5.158-12.798,7.564-14.414c0.52-0.35,0.747-0.987,0.563-1.588C31.604,2.901,31.061,2.5,30.431,2.5 c-9.048,0.034-16.481,3.94-20.394,10.717C7.108,18.288,6.348,24.423,7.95,30.048c1.543,5.427,5.076,9.855,9.948,12.469 c3.636,1.952,7.561,2.983,11.349,2.983c0.002,0,0.003,0,0.005,0c4.383,0,8.555-1.355,12.064-3.92 C41.809,41.218,42.014,40.585,41.826,40.005z M14,19.5c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5h0.54 c0.204,2.837,2.077,5,4.46,5c1.218,0,2.303-0.572,3.105-1.502c0.656,1.114,1.423,1.958,2.133,2.567l-0.978,0.652 c-0.516,0.342-0.747,0.972-0.575,1.568c0.251,0.871,0.942,1.95,1.941,3.087l-0.919,0.152c-1.887,0.233-4.162-0.603-5.646-2.086 l-1-1c-0.586-0.586-1.535-0.586-2.121,0s-0.586,1.535,0,2.121l1,1c1.879,1.879,4.574,2.998,7.145,2.998 c0.354,0,0.706-0.021,1.053-0.065l3.107-0.514c0.033-0.005,0.063-0.018,0.095-0.026c2.457,1.988,5.632,3.831,8.959,4.768 c-5.229,2.271-11.371,1.859-17.065-1.195c-4.189-2.248-7.231-6.065-8.565-10.751c-1.393-4.895-0.731-10.232,1.817-14.646 c2.831-4.902,7.795-8.07,14.069-9.012c-1.993,2.326-5.467,7.306-5.724,13.882H14z M20.466,22.5c-0.157,1.172-0.843,2-1.466,2 s-1.309-0.828-1.466-2H20.466z M24.426,24.368c-0.282-0.514-0.534-1.106-0.724-1.79L23.699,22.5h1.767 C25.345,23.407,24.906,24.097,24.426,24.368z" />
      </svg>
      <h2>Dark Mode</h2>
    </div>
  );
};

export default ColorMode;
